/**
 * Pagination - Page navigation component
 */
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const showPages = 5;
    let start = Math.max(1, page - Math.floor(showPages / 2));
    let end = Math.min(totalPages, start + showPages - 1);
    if (end - start + 1 < showPages) {
      start = Math.max(1, end - showPages + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="flex items-center justify-center gap-1.5 mt-8" data-testid="pagination">
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8"
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        data-testid="pagination-prev"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      {getPageNumbers().map((p) => (
        <Button
          key={p}
          variant={p === page ? "default" : "outline"}
          size="icon"
          className={`h-8 w-8 text-xs ${p === page ? "bg-[#18181B]" : ""}`}
          onClick={() => onPageChange(p)}
          data-testid={`pagination-page-${p}`}
        >
          {p}
        </Button>
      ))}
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8"
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        data-testid="pagination-next"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
